// extracted by mini-css-extract-plugin
export default {"pageContentHolder":"BasePage_pageContentHolder__E4GfQ"};